import { makeStyles } from "@material-ui/core/styles";
import { ContactSection } from "@components/layout/section/contact/contactCard.js";
import contactPageStyle from "assets/jss/page/contact/style.js";
import * as React from 'react';
export default {
  makeStyles,
  ContactSection,
  contactPageStyle,
  React
};